import { useLocation } from '@reach/router';

export const useIsSample = (slug?: string) => {
  const location = useLocation();
  const sampleSlug = '/samples';
  const isSample = slug
    ? slug.startsWith(sampleSlug)
    : location.pathname
        .replace(/^\/([a-z]{2}-[a-z]{2})/g, '')
        .startsWith(sampleSlug);

  return { isSample };
};
